import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/')({
  component: SettingsIndexRoute,
});

function SettingsIndexRoute() {
  return <Navigate to='/settings/users' />;
}
